// src/components/resources/calculators/video-dropoff/utils/formatters.ts

/**
 * @file Video Dropoff Calculator Formatters
 * @description Utility functions for formatting time and data display
 */

/**
 * Utility function for consistent time formatting
 * @param {number} seconds - Time in seconds to format
 * @param {boolean} includeUnits - Whether to include 's' suffix
 * @returns {string} Formatted time string
 */
export const formatTime = (seconds: number, includeUnits = true): string => {
  // Always format in seconds, with consistent decimals
  const roundedValue = Math.round(seconds * 10) / 10
  
  // Remove trailing .0 if present
  const displayValue = roundedValue % 1 === 0 
    ? Math.floor(roundedValue) 
    : roundedValue
  
  return includeUnits ? `${displayValue}s` : String(displayValue)
}

/**
 * Format time with percentage for tooltip display
 * @param {number} seconds - Time in seconds
 * @param {number} videoLength - Total video length in seconds
 * @returns {string} Formatted time with percentage
 */
export const formatTimeWithPercentage = (seconds: number, videoLength: number): string => {
  const timeString = formatTime(seconds)
  const percentComplete = Math.min(100, Math.round((seconds / videoLength) * 100))
  return `${timeString} (${percentComplete}%)`
}
